// http.js
import axios from 'axios';


const server = axios.create({
//  baseURL:  'http://101.132.252.13:8080/backApi',//安徽
    // baseURL:  'http://120.224.150.2:15009',//金佰特
    // baseURL:  'http://192.168.31.31:8091/backApi',
  // baseURL:  'http://115.29.196.208:8080/backApi',万利达
    //  baseURL:  'https://www.zhongyanzhiye.com/backApi',
    baseURL:  'https://ahhbzxcy.com/backApi',
        //  baseURL:  'http://60.205.242.98:8080/backApi',//百晓生

  timeout: 50000, // 设置请求超时时间
  // headers: {
  //   'Content-Type': 'application/json;charset=UTF-8'
  // }
});

// 添加请求拦截器
server.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，例如添加 token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = ` ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
server.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么，例如处理状态码
    if (response.status === 200) {
      return response.data;
    } else {
      return Promise.reject(new Error(response.statusText));
    }
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default  server;
